<template>
  <div style="position: relative">
    <div v-if="type === '2'" class="verify-img-out">
      <!-- width: setSize.imgWidth, -->
      <div
        class="verify-img-panel"
        :style="{
          width: '100%',
          height: containerHeight,
        }"
      >
        <img
          :src="
            backImgBase ? 'data:image/png;base64,' + backImgBase : defaultImg
          "
          alt=""
          style="width: 100%; height: 100%; display: block"
        />
        <div v-show="showRefresh" class="verify-refresh" @click="refresh">
          <i class="refresh-icon">↻</i>
        </div>
        <transition name="tips">
          <span
            v-if="tipWords"
            class="verify-tips"
            :class="passFlag ? 'suc-bg' : 'err-bg'"
            >{{ tipWords }}</span
          >
        </transition>
      </div>
      <!-- 拼图块显示在背景图片上方 -->
      <div
        v-if="type === '2' && blockBackImgBase"
        class="verify-sub-block"
        :style="{
          width: puzzleBlockWidth,
          height: subHeight,
          left: puzzleBlockPositionLeft,
          top: '0px',
          transition: transitionLeft,
        }"
      >
        <img
          :src="'data:image/png;base64,' + blockBackImgBase"
          alt="拼图块"
          style="width: 100%; height: 100%; display: block; object-fit: contain"
        />
      </div>
    </div>
    <!-- 公共部分 -->
    <div
      class="verify-bar-area"
      :style="{
        width: '600px',
        height: barAreaHeight,
        'line-height': barAreaHeight,
      }"
    >
      <span class="verify-msg" v-text="text" />
      <div
        class="verify-left-bar"
        :style="{
          width: leftBarWidth !== undefined ? leftBarWidth : '0px',
          height: barAreaHeight,
          'border-color': leftBarBorderColor,
          transition: transitionWidth,
        }"
      >
        <span class="verify-msg" v-text="finishText" />
        <div
          class="verify-move-block"
          :style="{
            width: puzzleBlockWidth,
            height: barAreaHeight,
            'background-color': moveBlockBackgroundColor,
            left: moveBlockLeft !== undefined ? moveBlockLeft : '0px',
            transition: transitionLeft,
          }"
          @touchstart.stop="start"
          @mousedown="start"
        >
          <i :class="['verify-icon', iconClass]" :style="{ color: iconColor }">
            <span v-if="iconClass === 'icon-right'">→</span>
            <span v-else-if="iconClass === 'icon-check'">✓</span>
            <span v-else-if="iconClass === 'icon-close'">✗</span>
          </i>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
/**
 * VerifySlide
 * @description 滑块
 * */
import { aesEncrypt } from "./../utils/ase";
import { resetSize } from "./../utils/util";
import { reqGet, reqCheck } from "./../api/index";
import { isMobile } from "@components/verifition/utils/util";
//  "captchaType":"blockPuzzle",
export default {
  name: "VerifySlide",
  props: {
    captchaType: {
      type: String,
    },
    type: {
      type: String,
      default: "1",
    },
    // 弹出式pop，固定fixed
    mode: {
      type: String,
      default: "fixed",
    },
    vSpace: {
      type: Number,
      default: 5,
    },
    explain: {
      type: String,
      default: "向右滑动完成验证",
    },
    imgSize: {
      type: Object,
      default() {
        return {
          width: "310px",
          height: "155px",
        };
      },
    },
    blockSize: {
      type: Object,
      default() {
        return {
          width: "50px",
          height: "50px",
        };
      },
    },
    barSize: {
      type: Object,
      default() {
        return {
          width: "310px",
          height: "40px",
        };
      },
    },
    defaultImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      secretKey: "", // 后端返回的加密秘钥 字段
      passFlag: "", // 是否通过的标识
      backImgBase: "", // 验证码背景图片
      blockBackImgBase: "", // 验证滑块的背景图片
      backToken: "", // 后端返回的唯一token值
      jigsawY: 0, // 拼图的 Y 坐标
      startMoveTime: "", // 移动开始的时间
      endMovetime: "", // 移动结束的时间
      tipsBackColor: "", // 提示词的背景颜色
      tipWords: "",
      text: "",
      finishText: "",
      setSize: {
        imgHeight: 0,
        imgWidth: 0,
        barHeight: 0,
        barWidth: 0,
      },
      top: 0,
      left: 0,
      moveBlockLeft: undefined,
      leftBarWidth: undefined,
      // 移动中样式
      moveBlockBackgroundColor: undefined,
      leftBarBorderColor: "#ddd",
      iconColor: undefined,
      iconClass: "icon-right", // icon-right, icon-check, icon-close
      status: false, // 鼠标状态
      isEnd: false, // 是够验证完成
      showRefresh: true,
      transitionLeft: "",
      transitionWidth: "",
    };
  },
  computed: {
    containerHeight() {
      return isMobile() ? "100%" : this.setSize.imgHeight;
    },
    subHeight() {
      return isMobile() ? undefined : this.setSize.imgHeight;
    },
    barArea() {
      return this.$el ? this.$el.querySelector(".verify-bar-area") : null;
    },
    resetSize() {
      return resetSize;
    },
    // 获取实际图片宽度
    actualImgWidth() {
      if (this.$el) {
        const imgPanel = this.$el.querySelector(".verify-img-panel");
        // 新增日志：查看imgPanel的宽度
        if (imgPanel) {
          // console.log("imgPanel.offsetWidth:", imgPanel.style.width);
          if (imgPanel.offsetWidth > 0) {
            // console.log("返回imgPanel宽度:", imgPanel.offsetWidth);
            return imgPanel.offsetWidth;
          }
        } else {
          console.log("未找到.verify-img-panel元素");
        }
      }
      // 新增日志：查看setSize.imgWidth的值
      // console.log("this.setSize.imgWidth:", this.setSize.imgWidth);
      const width = parseInt(this.setSize.imgWidth) || 310;
      // console.log("actualImgWidth最终返回:", width);
      return width;
    },
    // 计算拼图块宽度（拼图块宽度约为图片宽度的 15%）
    puzzleBlockWidth() {
      // console.log("视口窗口宽度", document.documentElement.clientWidth);
      const intWidth = document.documentElement.clientWidth;
      let newWidth = 47;
      if (intWidth <= 375) {
        newWidth = 42;
      } else if (intWidth < 400 && intWidth >= 375) {
        newWidth = 44;
      }
      const baseWidth = Math.floor((this.actualImgWidth * newWidth) / 280);

      const minWidth = 40;
      const targetWidth = Math.max(baseWidth, minWidth);

      return this.$parent.ismobileModel
        ? targetWidth + "px"
        : targetWidth + "px";
    },
    // 计算拼图块的 left 位置，使其在滑块块上居中显示
    puzzleBlockLeft() {
      const blockSize = parseInt(this.barSize.height) || 40;
      const puzzleWidth = parseInt(this.puzzleBlockWidth) || 47;
      // 计算居中位置：滑块块宽度的一半减去拼图块宽度的一半
      const left = (blockSize - puzzleWidth) / 2;
      return left + "px";
    },
    // 计算拼图块在背景图片上的位置（与滑块块在同一竖线，移动速度1:1）
    puzzleBlockPositionLeft() {
      // 获取滑块移动的距离（相对于滑块轨道的距离）
      // 直接使用这个距离，不进行比例转换，确保移动速度完全一致（1:1）
      const moveDistance =
        parseInt((this.moveBlockLeft || "0").replace("px", "")) || 0;
      // console.log("moveDistance-移动的距离:", moveDistance);
      // 获取背景图片的实际宽度和拼图块宽度（用于边界检查）
      const imgWidth = this.actualImgWidth;
      const puzzleWidth = parseInt(this.puzzleBlockWidth) || 47;

      // 直接使用滑块的移动距离，确保移动速度完全一致（1:1）
      // 拼图块左边缘对齐到滑块块左边缘，保持在同一竖线上
      const puzzleLeft = moveDistance;
      // console.log("puzzleLeft:", puzzleLeft);
      // 确保拼图块不超出背景图片范围
      const maxLeft = imgWidth;
      // console.log("imgWidth背景图宽度", imgWidth);
      // console.log("maxLeft:", maxLeft);
      // console.log("maxLeft22:", Math.max(0, Math.min(puzzleLeft, maxLeft)));
      return Math.max(0, Math.min(puzzleLeft, maxLeft)) + "px";
      // const moveDistance =
      //   parseInt((this.moveBlockLeft || "0").replace("px", "")) || 0;
      // console.log("moveDistance:", moveDistance);

      // // 2. 解析拼图块宽度（保留原有逻辑）
      // const puzzleWidth = parseInt(this.puzzleBlockWidth) || 47;
      // console.log("puzzleWidth:", puzzleWidth);

      // // 3. 🔥 核心修改：用滑块轨道宽度替代异常的actualImgWidth
      // // 轨道宽度是拖拽区域的实际宽度，移动端不会异常（比如300px左右）
      // const trackWidth = this.barArea?.offsetWidth || 310;
      // console.log("轨道宽度trackWidth:", trackWidth);

      // // 4. 计算拼图块最大可移动距离（基于轨道宽度，而非异常的图片宽度）
      // // 移动端拼图块宽度若有缩放，同步适配
      // const finalPuzzleWidth = this.$parent?.ismobileModel
      //   ? Math.floor(puzzleWidth)
      //   : puzzleWidth;
      // const maxLeft = Math.max(0, trackWidth - finalPuzzleWidth);
      // console.log("maxLeft(基于轨道):", maxLeft);

      // // 5. 最终位置（限制在0~maxLeft之间）
      // const finalLeft = Math.max(0, Math.min(moveDistance, maxLeft));
      // console.log("finalLeft:", finalLeft);

      // return finalLeft + "px";
    },
    // 计算缩小后的滑块区域高度（缩小一半）
    // 计算滑块区域高度（优化移动端高度）
    barAreaHeight() {
      const baseHeight = parseInt(this.barSize.height) || 40;
      return this.$parent.ismobileModel
        ? baseHeight + "px" // 轻微缩小，保持合适高度
        : baseHeight + "px";
    },
  },
  watch: {
    // type变化则全面刷新
    type: {
      immediate: true,
      handler() {
        this.init();
      },
    },
  },
  mounted() {
    // 禁止拖拽
    this.$el.onselectstart = function () {
      return false;
    };
    console.log(this.defaultImg);
  },
  methods: {
    init() {
      this.text = this.explain;
      this.getPictrue();
      this.$nextTick(() => {
        const setSize = this.resetSize(this); // 重新设置宽度高度
        for (const key in setSize) {
          this.setSize[key] = setSize[key];
        }
        this.$parent.$emit("ready", this);
      });

      var _this = this;

      window.removeEventListener("touchmove", function (e) {
        _this.move(e);
      });
      window.removeEventListener("mousemove", function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.removeEventListener("touchend", function () {
        _this.end();
      });
      window.removeEventListener("mouseup", function () {
        _this.end();
      });

      window.addEventListener("touchmove", function (e) {
        _this.move(e);
      });
      window.addEventListener("mousemove", function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.addEventListener("touchend", function () {
        _this.end();
      });
      window.addEventListener("mouseup", function () {
        _this.end();
      });
    },

    // 鼠标按下
    start: function (e) {
      e = e || window.event;
      if (!e.touches) {
        // 兼容PC端
        var x = e.clientX;
        console.log("PC端x:", x);
      } else {
        // 兼容移动端
        var x = e.touches[0].pageX;
        console.log("移动端x:", x);
      }
      this.startLeft = Math.floor(
        x - this.barArea.getBoundingClientRect().left
      );
      console.log("startLeft:", this.startLeft);
      this.startMoveTime = +new Date(); // 开始滑动的时间
      if (this.isEnd == false) {
        this.text = "";
        this.moveBlockBackgroundColor = "#337ab7";
        this.leftBarBorderColor = "#337AB7";
        this.iconColor = "#fff";
        e.stopPropagation();
        this.status = true;
      }
    },
    // 鼠标移动
    move: function (e) {
      e = e || window.event;
      if (this.status && this.isEnd == false) {
        if (!e.touches) {
          // 兼容PC端
          var x = e.clientX;
          let bar_area_left = this.barArea.getBoundingClientRect().left;
          let move_block_left = x - bar_area_left; // 小方块相对于父元素的left值
          if (
            move_block_left >=
            this.barArea.offsetWidth -
              parseInt(parseInt(this.blockSize.width) / 2) -
              2
          ) {
            move_block_left =
              this.barArea.offsetWidth -
              parseInt(parseInt(this.blockSize.width) / 2) -
              2;
          }
          if (move_block_left <= 0) {
            move_block_left = parseInt(parseInt(this.blockSize.width) / 2);
          }
          // 拖动后小方块的left值
          this.moveBlockLeft = move_block_left - this.startLeft + "px";
          this.leftBarWidth = move_block_left - this.startLeft + "px";
        } else {
          // 兼容移动端
          let point = e.touches[0];
          // 关键：改用视口坐标clientX，与bar_area_left（视口坐标）统一
          let x = point.clientX;
          console.log(
            "正在移动时，移动端x:",
            x,
            "视口坐标clientX:",
            point.clientX
          );

          let bar_area_left = this.barArea.getBoundingClientRect().left;
          let move_block_left = x - bar_area_left; // 小方块相对于父元素的left值
          if (
            move_block_left >=
            this.barArea.offsetWidth -
              parseInt(parseInt(this.blockSize.width) / 2) -
              2
          ) {
            move_block_left =
              this.barArea.offsetWidth -
              parseInt(parseInt(this.blockSize.width) / 2);
          }
          if (move_block_left <= 0) {
            move_block_left = parseInt(parseInt(this.blockSize.width) / 2);
          }
          // 拖动后小方块的left值
          this.moveBlockLeft = move_block_left - this.startLeft + "px";
          this.leftBarWidth = move_block_left - this.startLeft + "px";
        }
      }
    },

    // 鼠标松开
    end: function () {
      this.endMovetime = +new Date();
      var _this = this;
      // 判断是否重合
      if (this.status && this.isEnd == false) {
        var moveLeftDistance = parseInt(
          (this.moveBlockLeft || "").replace("px", "")
        );
        moveLeftDistance =
          (moveLeftDistance * 310) / parseInt(this.setSize.imgWidth);

        // 获取拼图的 Y 坐标（如果有的话，否则使用默认值）
        const jigsawY = this.jigsawY || 5.0;

        const data = {
          captchaType: this.captchaType,
          pointJson: this.secretKey
            ? aesEncrypt(
                JSON.stringify({ x: moveLeftDistance, y: jigsawY }),
                this.secretKey
              )
            : JSON.stringify({ x: moveLeftDistance, y: jigsawY }),
          token: this.backToken,
        };
        reqCheck(data).then((res) => {
          if (res.repCode == "0000") {
            this.moveBlockBackgroundColor = "#5cb85c";
            this.leftBarBorderColor = "#5cb85c";
            this.iconColor = "#fff";
            this.iconClass = "icon-check";
            this.showRefresh = false;
            this.isEnd = true;
            if (this.mode == "pop") {
              setTimeout(() => {
                this.$parent.clickShow = false;
                this.refresh();
              }, 1500);
            }
            this.passFlag = true;
            this.tipWords = `${(
              (this.endMovetime - this.startMoveTime) /
              1000
            ).toFixed(2)}s验证成功`;
            // 获取拼图的 Y 坐标（如果有的话，否则使用默认值）
            const jigsawY = this.jigsawY || 5.0;
            // 返回验证参数，用于二次验证
            const verifyParams = {
              captchaType: this.captchaType,
              token: this.backToken,
              captchaVerification: this.secretKey
                ? aesEncrypt(
                    this.backToken +
                      "---" +
                      JSON.stringify({ x: moveLeftDistance, y: jigsawY }),
                    this.secretKey
                  )
                : this.backToken +
                  "---" +
                  JSON.stringify({ x: moveLeftDistance, y: jigsawY }),
            };
            setTimeout(() => {
              this.tipWords = "";
              if (this.$parent && this.$parent.closeBox) {
                this.$parent.closeBox();
              }
              this.$parent.$emit("success", verifyParams);
            }, 1000);
          } else {
            this.moveBlockBackgroundColor = "#d9534f";
            this.leftBarBorderColor = "#d9534f";
            this.iconColor = "#fff";
            this.iconClass = "icon-close";
            this.passFlag = false;
            setTimeout(function () {
              _this.refresh();
            }, 1000);
            this.$parent.$emit("error", this);
            this.tipWords = "验证失败";
            setTimeout(() => {
              this.tipWords = "";
            }, 1000);
          }
        });
        this.status = false;
      }
    },

    refresh: function () {
      this.showRefresh = true;
      this.finishText = "";

      this.transitionLeft = "left .3s";
      this.moveBlockLeft = "0px";

      this.leftBarWidth = undefined;
      this.transitionWidth = "width .3s";

      this.leftBarBorderColor = "#ddd";
      this.moveBlockBackgroundColor = "#fff";
      this.iconColor = "#000";
      this.iconClass = "icon-right";
      this.isEnd = false;

      this.getPictrue();
      setTimeout(() => {
        this.transitionWidth = "";
        this.transitionLeft = "";
        this.text = this.explain;
      }, 300);
    },

    // 请求背景图片和验证图片
    getPictrue() {
      // 生成客户端唯一标识
      let clientUid = localStorage.getItem("slider");
      if (!clientUid) {
        clientUid =
          "client_" +
          Date.now() +
          "_" +
          Math.random().toString(36).substr(2, 9);
        localStorage.setItem("slider", clientUid);
      }

      const data = {
        captchaType: this.captchaType,
        clientUid: clientUid,
        ts: Date.now(), // 现在的时间戳
      };
      reqGet(data).then((res) => {
        if (res.repCode == "0000") {
          this.backImgBase = res.repData.originalImageBase64;
          this.blockBackImgBase = res.repData.jigsawImageBase64;
          this.backToken = res.repData.token || res.repData.secretKey;
          this.secretKey = res.repData.secretKey;
          // 获取拼图的 Y 坐标（如果有的话）
          this.jigsawY = res.repData.jigsawY || res.repData.y || 0;
        } else {
          this.tipWords = res.repMsg;
        }

        // 判断接口请求次数是否失效
        if (res.repCode == "6201") {
          this.backImgBase = null;
          this.blockBackImgBase = null;
        }
      });
    },
  },
};
</script>

<style scoped>
/* 新增移动端样式调整 */
@media (max-width: 768px) {
  /* 修复.verify-img-panel宽度异常 */
  .verify-img-panel {
    width: 100% !important; /* 自适应父容器宽度 */
    min-width: 280px !important; /* 移动端最小宽度，避免缩到20px */
    max-width: 600px !important; /* PC端上限，按需调整 */
    box-sizing: border-box; /* 避免padding/border挤宽度 */
    display: block !important; /* 确保元素渲染（不是inline/隐藏） */
    overflow: hidden; /* 防止内部内容撑破 */
  }

  /* 若有父容器，也确保父容器宽度正常 */
  .verify-img-container {
    width: 100%;
    padding: 0 10px; /* 移动端加内边距，适配屏幕 */
    box-sizing: border-box;
  }
  .verify-bar-area {
    width: 100% !important;
  }

  .verify-refresh {
    width: 24px;
    height: 24px;
    font-size: 14px;
  }

  .verify-icon {
    font-size: 20px;
  }
}
/* .verify-img-out {
  position: relative;
  padding: 1px;
} */

.verify-img-panel {
  position: relative;
  box-sizing: border-box;
  text-align: center;
  border: 1px solid #ddd;
  background: #fff;
  width: 150px;
  z-index: 1;
  overflow: visible;
}

.verify-refresh {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 5;
  cursor: pointer;
  font-size: 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.verify-refresh:hover {
  background: rgba(0, 0, 0, 0.5);
}

.verify-tips {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  z-index: 10;
}

.suc-bg {
  background: rgba(92, 184, 92, 0.8);
}

.err-bg {
  background: rgba(217, 83, 79, 0.8);
}

.verify-bar-area {
  position: relative;
  box-sizing: border-box;
  background: #f7f9fa;
  color: #45494c;
  border: 1px solid #e4e7eb;
  text-align: left;
  border-radius: 2px;
  overflow: hidden;
}

.verify-left-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  background: #1991fa;
  border-color: #1991fa;
  border-style: solid;
  border-width: 0 0 0 1px;
}

.verify-move-block {
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  cursor: pointer;
  text-align: center;
  border: 1px solid #1991fa;
  box-sizing: border-box;
  z-index: 2;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
}

.verify-icon {
  font-size: 28px;
  line-height: 1;
  display: inline-block;
  font-style: normal;
  font-weight: bold;
}

.refresh-icon {
  font-size: 18px;
  display: inline-block;
  font-style: normal;
}

.verify-sub-block {
  position: absolute;
  left: 0;
  top: 0;
  background: transparent;
  z-index: 100;
  box-sizing: border-box;
  /* border: 2px solid #fff; */
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.5); */
  pointer-events: none;
  overflow: visible;
}

.verify-sub-block img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: transparent;
}

.verify-msg {
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
}

.tips-enter-active,
.tips-leave-active {
  transition: opacity 0.3s;
}

.tips-enter,
.tips-leave-to {
  opacity: 0;
}
</style>


